<template>
    <div>
        <el-form :hide-required-asterisk="true" :model="formModel" status-icon label-width="80px"
                 label-position="left">
            <el-row style="margin: 10px">
                <el-form-item size="mini" label="选择小组:">

                    <!-- 级连选择 -->
                    <el-cascader
                            popper-class="_create_group_craft"
                            v-model="GroupCraft.produce_group"
                            filterable
                            placeholder="请选择"
                            :show-all-levels="false"
                            :options="CasCaderOptions"
                            :props="{ expandTrigger: 'hover' }"
                    ></el-cascader>
                </el-form-item>
            </el-row>
            <el-divider></el-divider>
            <el-table :data="GroupCraft.sizegroupcraftrecord_set">
                <el-table-column width="155" prop="shop_id" label="尺码"></el-table-column>
                <el-table-column prop="num" label="通知数量"></el-table-column>
                <el-table-column prop="has_planed" label="已分配数量"></el-table-column>
                <el-table-column width="150" align="center" label="小组分派数量">
                    <template slot-scope="scope">
                        <el-input-number
                                size="mini"
                                v-model="scope.row.plan_num"
                                :max="scope.row.plan_num"
                                :min="0"
                                :step="1"
                        >
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column width="150" align="center" label="小组工价">
                    <template slot-scope="scope">
                        <el-input-number
                                size="mini"
                                v-model="scope.row.price"
                                :min="0"
                                :step="0.01"
                        >
                        </el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <el-divider></el-divider>

            <el-row :gutter="20" style="margin-top: 10px;margin-left: 10px">


                <el-form-item label="小组工期:" :rules="rules.planDate" prop="GroupCraftPlanDate">
                    <el-date-picker
                            index="3000"
                            :prefix-icon="datePickerIcon"
                            v-model="formModel.GroupCraftPlanDate"
                            type="datetimerange"
                            size="mini"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            range-separator="至"
                            :clearable="false"
                            :default-time="['8:30:00','21:30:00']"
                    >
                    </el-date-picker>

                    <slot slot-scope="scope" slot="error">
                        <div class="el-form-item__error">
                            <el-popover
                                    placement="bottom"
                                    width="850"
                                    trigger="click">
                                <el-row style="margin: 6px 2px">
                                    <el-table :data="overRangeCraft">
                                        <el-table-column prop="base_id" width="140" label="款号"/>
                                        <el-table-column prop="craft_name" width="60" label="工艺"/>
                                        <el-table-column prop="created" label="小组任务创建"/>
                                        <el-table-column width="80" prop="plan_num" label="分配数量"/>
                                        <el-table-column width="90" prop="finish_num" label="已上报数量"/>
                                        <el-table-column prop="finish_num" label="计划开始">
                                            <template slot-scope="{row}">
                                                <el-tag size="mini" type="primary">{{ row.plan_start }}</el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="计划结束">
                                            <template slot-scope="{row}">
                                                <el-tag size="mini" type="primary">{{ row.plan_end }}</el-tag>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-row>
                                <el-link style="font-size: 12px"
                                         type="danger"
                                         slot="reference">
                                    {{ scope.error }}
                                    <i class="el-icon-view el-icon--right"></i>
                                </el-link>
                            </el-popover>
                        </div>

                    </slot>
                </el-form-item>


            </el-row>
            <el-row :gutter="20" style="margin-bottom: 10px">
                <div style="padding: 0 10px">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 5}"
                            placeholder="备注"
                            v-model="GroupCraft.remark">
                    </el-input>
                </div>

            </el-row>
        </el-form>
        <el-divider></el-divider>
        <el-button type="primary" :loading="createGroupCraftLoading" size="mini" style="margin-left: 10px"
                   @click="createGroupCraft()">完成
        </el-button>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: "CreateGroupCraft",
        data() {
            const requiredValidated = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('必填项'));
                } else {
                    callback();
                }
            }
            return {
                // 下拉选择的配置信息

                selectProps: {
                    checkStrictly: true,
                    label: 'name',
                    value: 'id',
                },

                formModel: {
                    GroupCraftPlanDate: '',
                },
                datePickerIcon: '',
                overRangeCraft: [],
                createGroupCraftLoading: false,
                GroupCraft: {
                    produce_group: '',
                    craft_record: '',
                    remark: '',
                    plan_start: '',
                    plan_end: '',
                    sizegroupcraftrecord_set: [],
                },
                rules: {
                    planDate: [{validator: this.asyncCheckPlanDate, trigger: 'blur'}],
                    requiredRules: [{validator: requiredValidated, trigger: 'select'},]
                }

            }
        },
        computed: {
            ...mapGetters(["CasCaderOptions"]),
            ...mapState({
                craft: "currentCraft",
            })
        },
        methods: {

            asyncCheckPlanDate(rule, value, callback) {
                this.overRangeCraft.length = 0
                if (!value) {
                    this.handleDatePickerError()
                    callback(new Error('小组工期为必填项'));

                } else if (!this.GroupCraft.produce_group) {
                    this.handleDatePickerError()
                    callback(new Error('必须选中小组，才能分配工期'));
                } else {
                    const startDate = value[0]
                    const endDate = value[1]
                    if (startDate.getTime() <= new Date().getTime()) {
                        this.handleDatePickerError()
                        callback(new Error('计划开始日期必须 "大于" 当前日期'));
                    } else {
                        this.datePickerIcon = 'el-icon-loading'

                        // 数组包含两层节点
                        // 子节点为 produce_group 值
                        const produce_group = this.GroupCraft.produce_group[1]

                        const groupCraftUrl = `${this.$const.craftGroupRecordUrl}?finish=false&produce_group=${produce_group}`
                        this.$getRequest(groupCraftUrl)
                            .then(response => {
                                response.data.forEach(craft => {
                                    const _startDate = new Date(craft.plan_start)
                                    const _endDate = new Date(craft.plan_end)
                                    if (!(startDate.getTime() >= _endDate.getTime() || endDate.getTime() <= _startDate.getTime())) {
                                        // 出现时间交叉/重叠
                                        this.overRangeCraft.push(craft)
                                    }
                                })
                                const overRangeCraftLen = this.overRangeCraft.length
                                if (overRangeCraftLen > 0) {
                                    this.handleDatePickerError()
                                    callback(new Error(`和该小组的${overRangeCraftLen}个安排时间出现重复`));
                                } else {
                                    this.datePickerIcon = 'el-icon-circle-check'
                                    this.GroupCraftPlanDateCheck = true
                                    callback()
                                }

                            })
                            .catch(error => {
                                this.datePickerIcon = 'el-icon-circle-close'
                                callback(new Error('获取小组工期数据失败！'));
                            })
                    }
                }
            },
            setupGroupCraft() {
                this.init()

                this.GroupCraft.craft_record = this.craft.id
                this.craft.size_records.forEach((sizeRecord) => {
                    this.GroupCraft.sizegroupcraftrecord_set.push(
                        {
                            shop_id: sizeRecord.shop_id,         // 辅助字段 | 尺码数据
                            num: sizeRecord.num,                 // 辅助字段 ｜ 通知数量
                            has_planed: sizeRecord.has_planed,   // 辅助字段 ｜ 已分配数量

                            size_craft_record: sizeRecord.id,
                            plan_num: sizeRecord.num - sizeRecord.has_planed,
                            price: sizeRecord.price,
                        }
                    )
                })
            }
            ,
            handleDatePickerError() {
                this.datePickerIcon = 'el-icon-circle-close'
                this.GroupCraftPlanDateCheck = false
            }
            ,
            // 初始化数据
            init() {
                this.formModel.GroupCraftPlanDate = ''
                this.formModel.produceGroup = ''
                this.datePickerIcon = ''

                this.GroupCraftPlanDateCheck = false
                this.GroupCraft = {
                    produce_group: '',
                    craft_record: '',
                    remark: '',
                    plan_start: '',
                    plan_end: '',
                    sizegroupcraftrecord_set: [],
                }
            }
            ,

            // 检测数据是否完整
            checkGroupCraft() {
                if (!this.formModel.GroupCraftPlanDate) {
                    this.$message.error('小组工期为必填项')
                    return false
                } else {
                    this.GroupCraft.plan_start = this.formModel.GroupCraftPlanDate[0]
                    this.GroupCraft.plan_end = this.formModel.GroupCraftPlanDate[1]
                }
                if (!this.GroupCraftPlanDateCheck) {
                    this.$message.error('小组工期出错！')
                    return false
                }

                if (!this.GroupCraft.produce_group) {
                    this.$message.error('小组为必选项')
                    return false
                }


                let priceSum = 0.0
                let planSum = 0
                for (let i = 0; i < this.GroupCraft.sizegroupcraftrecord_set.length; i++) {
                    const sizeGroup = this.GroupCraft.sizegroupcraftrecord_set[i]

                    const surplusNum = sizeGroup.num - sizeGroup.has_planed
                    if (parseInt(sizeGroup.plan_num) > surplusNum) {
                        this.$message.error(`${sizeGroup.shop_id}分配数据超过可分配数量：${surplusNum}，请重新分配`)
                        return false
                    }

                    if (parseInt(sizeGroup.plan_num) < 0) {
                        this.$message.error(`${sizeGroup.shop_id}分配数据必须为正值`)
                        return false
                    }

                    priceSum += parseFloat(sizeGroup.price)
                    planSum += parseInt(sizeGroup.plan_num)

                }

                if (priceSum <= 0) {
                    this.$message.error(`工艺的价格为必填项`)
                    return false
                }
                if (planSum <= 0) {
                    this.$message.error(`分配的通知数量总和不能为0`)
                    return false
                }
                if (!this.GroupCraft.remark) {
                    delete this.GroupCraft.remark
                }
                return true
            }
            ,
            /**
             *
             * 创建小组任务单
             */
            createGroupCraft() {
                const checked = this.checkGroupCraft()
                if (checked) {
                    this.createGroupCraftLoading = true
                    const createUrl = this.$const.craftGroupRecordUrl

                    // this.GroupCraft 中的 produce_group 为级联选择中的数组路径
                    const data = JSON.parse(JSON.stringify(this.GroupCraft));
                    data.produce_group = this.GroupCraft.produce_group[1]

                    this.$postRequest(createUrl, data)
                        .then((response) => {
                            this.createGroupCraftLoading = false
                            this.$message.success('新建小组任务单成功')
                            const craft_record = response.data['craft_record']
                            this.$store.commit('updateCurrentCraft', craft_record)
                            this.setupGroupCraft()
                            this.setShowCraftCreateGroup(false)
                        })
                        .catch(error => {
                            this.createGroupCraftLoading = false
                        })
                }
            }
            ,

            ...mapMutations(['setShowCraftCreateGroup'])
        },
        created() {
            this.setupGroupCraft()
        },
        watch: {
            craft() {
                this.setupGroupCraft()
            },
        },

    }
</script>

<style scoped>
</style>
<style>

    ._create_group_craft .el-cascader-menu__list {
        max-height: 250px;
    }

    .create-group-craft-el-cascader .el-scrollbar {
        width: 300px
    }
</style>